import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RoleModel } from '../models/RoleModel';
import { obtenerRolesService, obtenerRolPorIdService } from '../../../../service/catalogos/Roles';

export const useObtenerRoles = (reload: number) => {
  const [data, setData] = useState<RoleModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      setLoadingRequest(true);
      const res = await obtenerRolesService()
        .then()
        .catch(() => {
          setLoadingRequest(false);
          history.push('/error/500');
        });
      if (res) {
        setData(res);
        setLoadingRequest(false);
      }
    };
    fetchData();
  }, [reload]);

  return { data, loadingRequest };
};

export const useObtenerRolPorId = (id: number) => {
  const initModel: RoleModel = { id: 0, name: '', code: '', description: '' };
  const [initValues, setInitValues] = useState<RoleModel>(initModel);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const res = await obtenerRolPorIdService(id)
        .then()
        .catch(() => {
          history.push('/error/500');
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchData();
    } else {
      setInitValues(initModel);
    }
  }, [id]);

  return { initValues };
};
